import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    h2: {
        id: "landing.why.h2",
    },
    p: {
        id: "landing.why.p",
    },
});

export default messages;
